import { materialIconGlyph } from '../../lib/materialIcons'

type MaterialIconProps = {
  name: string
  filled?: boolean
  hoverable?: boolean
  inactive?: boolean
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

const SIZE_CLASS = {
  sm: 'text-[18px]',
  md: 'text-[22px]',
  lg: 'text-[28px]',
  xl: 'text-[32px]',
} as const

const MaterialIcon = ({
  name,
  filled = false,
  hoverable = false,
  inactive = false,
  size = 'md',
  className = '',
}: MaterialIconProps) => (
  <span
    className={`material-symbols-outlined ${SIZE_CLASS[size]} ${filled ? 'material-symbol--filled text-kilo-accent' : inactive ? 'text-kilo-soft/40' : 'text-kilo-accent'} ${hoverable && !inactive ? 'material-symbol--hoverable' : ''} ${className}`}
    aria-hidden
  >
    {materialIconGlyph(name)}
  </span>
)

export default MaterialIcon
